<template>
  <article v-if='!kql.loading' :class='[ kql.page?.parent.id ]'>
    <header>
      <h5 v-if='kql.page?.content.date' v-html="dayjs(kql.page?.content.date).format('MMMM D, YYYY')" />
      <h2 v-html='kql.page.title' />
    </header>
    <section class='static layout' v-if='kql.page?.content?.content'>
      <LayoutBlock v-for='block in JSON.parse(kql.page?.content?.content)' :context='kql.page' :block='block'/>
    </section>
    <MainFooter/>
  </article>
</template>

<script setup>
import dayjs from 'dayjs';
import { useStore } from '../KQL.js'
const kql = useStore();
</script>

<style scoped>
@import '@/css/breakpoints.css';

section.static.layout {
    width: var(--main-width-narrow);
    margin: auto;
    padding-top: 3rem;
}

header {
  width: var(--main-width-narrow);
  margin: auto;
  padding-top: var(--top-padding);
}

article.writing section.static.layout {
  padding-top: 10rem;
}


article.writing header h2 {
  margin: auto;
  line-height: 1.2;
  max-width: 39rem;
  text-align: left;
}

article.writing header h5 {
  margin: auto;
  margin-bottom: 0;
  max-width: 39rem;
  text-align: left;
}

@media (--wide) {
  section
  :deep(div.textblock) p {
    max-width: 39rem;
  }
}


</style>
